import React, { Component } from "react";

import { Icon } from "components/Icon";
import { Alert } from "services/Alert";
import Recaptcha from "react-google-invisible-recaptcha";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";

import { APP_TYPE_ADMIN, APP_TYPE_DEFAULT, DEFAULT_ERROR_MESSAGE, DEFAULT_NOT_AUTH_PATH } from "const";
import { hideRecaptchaOverlay } from "utils";
import { notAuthApi } from "api/auth";
import VersionLabel from "components/VersionLabel/VersionLabel";
import { BaseButton } from "components/base/BaseButton";

import { ButtonToolbar, Container, Content, FlexboxGrid, Header, Nav, Navbar, Panel, Schema } from "rsuite";
import Form from "components/Form/CompatForm";

const { StringType } = Schema.Types;

const MIN_PASSWORD_LENGTH = 8;
const MAX_EMAIL_LENGTH = 120;

const resetPasswordFormModel = Schema.Model({
    password: StringType()
        .pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])[A-Za-z"\d#?!_@$%^&*-]{8,}$/,
            "Must contain at least one number and one uppercase and lowercase letter"
        )
        .minLength(MIN_PASSWORD_LENGTH, `Password must be at least ${MIN_PASSWORD_LENGTH} characters`)
        .isRequired("This field is required"),
    confirm_password: StringType()
        .isRequired("This field is required")
        .addRule((value, formValues) => (
            value === formValues.password
        ), "Passwords must be same")
});

export const requestFormModel = Schema.Model({
    email: StringType()
        .isRequired("Required")
        .maxLength(MAX_EMAIL_LENGTH, "Too long email address")
        .isEmail("Please enter an email address"),
});


class ResetPassword extends Component {

    constructor(props) {
        super(props);

        this.formRef = null;
        this.recaptchaRef = null;

        this.state = {
            isTokenValid: false,
            formValues: {},
            captchaIsVisible: false,
            hasHiddenRecaptcha: false
        };
    };

    componentDidMount() {
        const token = this.props.match.params.token;
        const savedToken = sessionStorage.getItem("RESET_TOKEN")
        document.body.classList.remove("rtl");

        if (token && token !== savedToken) {
            this.checkToken(token);
            sessionStorage.setItem("RESET_TOKEN", token)
        }

        const enableCaptcha = process.env.REACT_APP_ENABLE_CAPTCHA === "1";

        if (enableCaptcha && this.props.captchaNeeded) {
            this.setState({ captchaIsVisible: true });
        }
    };

    componentDidUpdate(prevProps) {
        const enableCaptcha = process.env.REACT_APP_ENABLE_CAPTCHA === "1";

        if (
            enableCaptcha &&
            !prevProps.captchaNeeded &&
            this.props.captchaNeeded &&
            !this.state.captchaIsVisible
        ) {
            this.setState({ captchaIsVisible: true });
        }
    }

    componentWillUnmount() {
        this.resetRecaptcha();
    };

    checkToken = (token) => {
        notAuthApi("account_user__reset_password:check", { token }).then(() => {
            this.setState({ isTokenValid: true });
        }).catch(() => {
            Alert.error("Token expired, please try to reset password again");
        });
    };

    handleSubmitResetRequest = () => {
        const formValues = this.formRef.getFormValue();

        if (!this.formRef.check()) {
            return;
        }

        this.executeRecaptcha();
    };

    setHiddenRecaptcha = (value) => {
        this.setState({ hasHiddenRecaptcha: value });
    };

    handleResolveCaptcha = (token) => {
        if (!token && this.state.captchaIsVisible) {
            Alert.error("Bot verification failed")
            this.resetRecaptcha();
            return;
        }


        const formValues = this.formRef.getFormValue();

        notAuthApi("account_user__reset_password:request", {
            ...formValues,
            site: 1,
            captcha_token: token
        })
            .then(response => {
                if (response !== undefined) {
                    Alert.success("Email was successfully sent! Check your SPAM folder");
                    this.props.history.push(DEFAULT_NOT_AUTH_PATH);
                }
            })
            .catch(() => {
                Alert.error("Incorrect email");
            })
            .finally(() => {
                const observer = new MutationObserver((mutations) => {
                    for (const mutation of mutations) {
                        for (const node of mutation.addedNodes) {
                            if (
                                node.tagName === "IFRAME" &&
                                node.style &&
                                node.style.zIndex === "2147483647"
                            ) {
                                hideRecaptchaOverlay(this.state.hasHiddenRecaptcha, this.setHiddenRecaptcha);
                                observer.disconnect();
                                return;
                            }
                        }
                    }
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true,
                });

                this.resetRecaptcha();
            });
    }


    handleSubmitNewPassword = () => {
        const password = this.formRef.getFormValue().password;
        const token = this.props.match.params.token;

        if (this.formRef.check()) {
            notAuthApi("account_user__reset_password:modify", { password, token }).then((response) => {
                Alert.success("Password successfully changed");
                // this.props.history.replace("/reload")
                this.props.history.push(DEFAULT_NOT_AUTH_PATH);
                this.resetRecaptcha();
                this.setState({ captchaIsVisible: false });
            }).catch(() => {
                Alert.error(DEFAULT_ERROR_MESSAGE);
            });
        }
    };


    executeRecaptcha = () => {
        if (!this.state.captchaIsVisible) {
            this.handleResolveCaptcha();
            return;
        }
        console.log(1);
        if (this.recaptchaRef?.execute) {
            this.recaptchaRef.execute();
        }
    }

    resetRecaptcha = () => {
        if (!this.state.captchaIsVisible) {
            return;
        }

        if (this.recaptchaRef?.reset) {
            this.recaptchaRef.reset();
        }
    }


    render() {
        const isTokenValid = this.state.isTokenValid;
        const captchaIsVisible = this.state.captchaIsVisible;

        return (
            <Container style={{ height: "100vh" }}>
                <Header>
                    <Navbar appearance="inverse">
                        <Navbar.Header>
                        </Navbar.Header>
                        <Navbar.Body>
                            <Nav pullRight>
                                <StyledNavItem
                                    as={Link}
                                    icon={<Icon icon="sign-in" />}
                                    to="/login"
                                >
                                    Log in
                                </StyledNavItem>
                            </Nav>
                        </Navbar.Body>
                    </Navbar>
                </Header>
                <Content >
                    <FlexboxGrid justify="center" >
                        <FlexboxGrid.Item colspan={12} >
                            <Panel
                                header={<h3>Reset Password</h3>}
                                bordered
                                style={{ marginTop: "15vh" }}
                            >

                                <>
                                    {!isTokenValid &&
                                        <Form fluid ref={ref => (this.formRef = ref)} model={requestFormModel}>
                                            <Form.Group>
                                                <Form.ControlLabel>Please, enter an email address</Form.ControlLabel>
                                                <Form.Control autoFocus={true} name="email" />
                                            </Form.Group>
                                            <Form.Group>
                                                <ButtonToolbar>
                                                    <StyledButton
                                                        type="submit"
                                                        onClick={this.handleSubmitResetRequest}
                                                    >
                                                        Reset
                                                    </StyledButton>
                                                </ButtonToolbar>
                                            </Form.Group>
                                        </Form>
                                    }

                                    {isTokenValid &&
                                        <Form fluid
                                            ref={ref => (this.formRef = ref)}
                                            model={resetPasswordFormModel}
                                            formValue={this.state.formValues}
                                            onChange={(formValues) => this.setState({ formValues })}
                                        >
                                            <Form.Group>
                                                <Form.ControlLabel>Password</Form.ControlLabel>
                                                <Form.Control autoFocus={true} name="password" type="password" />
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.ControlLabel>Confirm Password</Form.ControlLabel>
                                                <Form.Control name="confirm_password" type="password" />
                                            </Form.Group>
                                            <Form.Group>
                                                <ButtonToolbar>
                                                    <StyledButton
                                                        type="submit"
                                                        onClick={this.handleSubmitNewPassword}
                                                    >
                                                        Reset Password
                                                    </StyledButton>
                                                </ButtonToolbar>
                                            </Form.Group>
                                        </Form>
                                    }
                                </>

                                {captchaIsVisible && <Recaptcha
                                    ref={ref => this.recaptchaRef = ref}
                                    sitekey={process.env.REACT_APP_SITE_KEY}
                                    onResolved={this.handleResolveCaptcha}
                                />}

                            </Panel>
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                </Content>
                <VersionLabel />
            </Container>
        );
    }
}

const mapState = ({ auth }) => ({
    captchaNeeded: auth.captchaNeeded
});

export default connect(mapState)(withRouter(ResetPassword));

const StyledButton = styled(BaseButton).attrs(() => ({
    buttonStyle: APP_TYPE_DEFAULT === APP_TYPE_ADMIN ? "secondary" : "primary"
}))`
    && {
        min-width: 0;
    }
`;

const StyledNavItem = styled(Nav.Item)`
    .rs-nav-item-content {
    
        &:hover,
        &:active,
        &:focus {
            background-color: #20b188 !important;
        }
    }
`;
